import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router';
import { PersistGate } from 'redux-persist/es/integration/react';

import Login from 'components/views/Login';
import Main from 'components/views/Main';
import Popup from 'components/shared/popup/Popup';
import RegisterInfo from 'components/views/RegisterInfo';
import Goodbye from 'components/views/Goodbye';
import AgreementView from 'components/views/AgreementView';
import CookieInfo from 'components/views/CookieInfo';
import Verifications from 'components/views/Verifications';
import * as types from 'misc/types';
import { connect } from 'react-redux';

import { persistor } from './store';

import 'styles/main.css';

class App extends Component {
    componentDidMount() {
        console.log('FETCH TEXTS');
        const { dispatch } = this.props;
        // Fetch medias
        //dispatch({ type: types.SAGA_MEDIAS_GET.REQUEST });
        // Fetch cms text
        dispatch({ type: types.SAGA_TEXTS_GET.REQUEST });
    }

    render() {
        const { match } = this.props;

        return (
            <PersistGate loading={<p>Vänligen vänta...</p>} persistor={persistor}>
                <Switch>
                    <Route path="/agreement" component={AgreementView} />
                    <Route path="/goodbye" component={Goodbye} />
                    <Route path="/register_info" component={RegisterInfo} />
                    <Route path="/login" component={Login} />
                    <Route path="/cookie_info" component={CookieInfo} />
                    <Route path="/verifications/:token" component={Verifications} />

                    <Route path="/" component={Main} />
                </Switch>
                <Popup header="Hej" text="Lorem ipsum" />
            </PersistGate>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        texts: state.texts
    };
};

App = connect(mapStateToProps)(App);
export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js